(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function syncTeraviaFilterPanels() {
    var mobile = window.matchMedia('(max-width: 900px)').matches;
    document.querySelectorAll('[data-teravia-filter-toggle]').forEach(function (button) {
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      if (!mobile) panel.classList.remove('is-open');
      button.setAttribute('aria-expanded', mobile && panel.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-teravia-filter-toggle]');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.teravia-filter-sidebar.is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
      var button = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
    });
  });

  window.addEventListener('resize', syncTeraviaFilterPanels);
  document.addEventListener('DOMContentLoaded', syncTeraviaFilterPanels);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-teravia-filter-form]');
    if (!form || form.getAttribute('data-custom-tag-collection') !== 'true') return;
    event.preventDefault();

    var tags = [];
    var baseTag = form.getAttribute('data-base-tag');
    if (baseTag) tags.push(baseTag);
    form.querySelectorAll('[data-teravia-tag]:checked').forEach(function (input) {
      if (input.value && tags.indexOf(input.value) === -1) tags.push(input.value);
    });

    var params = new URLSearchParams(new FormData(form));
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('teravia_') === 0 || params.get(key) === '') params.delete(key);
    });
    params.delete('page');

    var target = form.getAttribute('data-collection-base') + (tags.length ? '/' + tags.join('+') : '');
    var query = params.toString();
    window.location.assign(target + (query ? '?' + query : ''));
  });

  document.addEventListener('change', function (event) {
    var filterForm = event.target.closest('[data-teravia-filter-form]');
    if (filterForm) {
      filterForm.requestSubmit();
      return;
    }
    var select = event.target.closest('[data-collection-sort-form] select[name="sort_by"]');
    if (!select) return;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', select.value);
    params.delete('page');
    window.location.assign(window.location.pathname + '?' + params.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
